// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
/* eslint-disable import/prefer-default-export */

/**
 * Indicates the type of host build.
 *
 * @type {string}
 */
const env = 'core';

export {env};
